export const CHECK_LOGIN = 'check_login';
export const LOGIN_USER_SUCCESSFUL = 'login_user_successfull';

export const LOGOUT_USER = 'LOGOUT_USER';
export const FORCE_LOGOUT = 'FORCE_LOGOUT';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';

export const API_ERROR = 'api_failed';

export const CLEAR_ALL_LOGIN_MESSAGES = 'clear_all_login_messages';
export const CLEAR_ALL_LOGIN_MESSAGES_SUCCESSFUL = 'clear_all_login_messages_successful';
